<div class="grid grid-nogutter text-sm font-medium border-bottom-1 lg:border-bottom-none border-300 mb-2 lg:mb-0">
  <div class="col">
    <div class="grid grid-nogutter">
      <div class="col-12 md:col-3 lg:col-3 p-1">
        <!-- <app-input-select idField="nomenclatura" labelField="parametro" [list]="list" name="name" icon="fact_check" placeholder="Controllo" [form]="toFormGroup(element)" [searchComponentTemplate]="searchComponent"></app-input-select> -->
        <app-parametri-input-select name="parametroId" [form]="toFormGroup(element)"></app-parametri-input-select>
      </div>
      <div class="col-12 md:col-2 lg:col-2 p-1">
        <div class="surface-50 border-round-md border-1 border-200 font-medium p-2 h-full flex align-items-center justify-content-center w-12" style="max-height: 48px;">
          <div *ngIf="item" class="flex flex-column w-12">
            <div class="flex w-12 justify-content-between">
              <span class="text-700">
                {{item.nomenclatura}}
              </span>
              <span class="text-sm font-light text-700">
                ({{item.unitaDiMisura}})
              </span>
            </div>
            <div class="flex w-12 justify-content-between">
              <span class="text-xs font-light">
                {{item.definizione}}
              </span>
            </div>            
          </div>
        </div>
      </div>
      <div  class="col-12 md:col-1 lg:col-1 p-1" *ngIf="item" [formGroup]="toFormGroup(element)">
        <mat-form-field  *ngIf="item?.tipologia=='chimico_fisico' || item?.tipologia=='antiparassitario'">
          <mat-label>Loq</mat-label>
          <mat-select matNativeControl formControlName="valoreLoq"  (change)="toFormGroup(element);">
            <mat-option value=""></mat-option>
            <mat-option value="<"><</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field  *ngIf="item?.tipologia=='microbiologico'" >
          <mat-label>Lsf</mat-label>
          <mat-select matNativeControl formControlName="valoreLfs"  (change)="toFormGroup(element);">
            <mat-option value=""></mat-option>
            <mat-option value=">">></mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div  class="col-12 md:col-2 lg:col-2 p-1" *ngIf="item">
        <app-input-number name="valoreArrotondato"  *ngIf="item?.tipologia!='qualitativo'"   placeholder="Valore Arrotondato" [form]="toFormGroup(element)"></app-input-number>
        <!--nel caso si trattasse di parametri tipo chimico fisico antiparassitario con loq < -->
        <app-input-number name="valoreRapportoProva"  *ngIf="((item?.tipologia=='chimico_fisico' || item?.tipologia=='antiparassitario') && element.get('valoreLoq')?.value==null) || (item?.tipologia=='microbiologico' && element.get('valoreLfs')?.value==null)"   placeholder="Valore Rapporto Prova" [form]="toFormGroup(element)"></app-input-number>
        <!--nel caso si trattasse di parametri tipo chimico fisico antiparassitario con loq < -->
        <app-input-number 
        name="loq" 
        *ngIf="((item?.tipologia == 'chimico_fisico' && element.get('valoreLoq')?.value == '<') || 
                (item?.tipologia == 'antiparassitario' && element.get('valoreLoq')?.value == '<'))" 
        placeholder="Valore Loq" 
        [form]="toFormGroup(element)">
      </app-input-number>
        <!--nel caso si trattasse di parametri tipo microbiologico con lsf > -->
        <app-input-number name="lfs"  *ngIf="(item?.tipologia=='microbiologico' && element.get('valoreLfs')?.value=='>')"   placeholder="Valore Lfs" [form]="toFormGroup(element)"></app-input-number>
        <!--nel caso si trattasse di parametri tipo odore-->
        <mat-form-field  *ngIf="item?.tipologia=='qualitativo'" [formGroup]="toFormGroup(element)">
          <mat-label>valore</mat-label>
          <mat-select matNativeControl formControlName="valore"  (change)="toFormGroup(element);">
            <mat-option [value]="0">NO</mat-option>
            <mat-option [value]="1">SI</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div  class="col-12 md:col-2 lg:col-2 p-1" >
        <app-input-text name="incertezza"   placeholder="Incertezza" [form]="toFormGroup(element)"></app-input-text>
      </div>
      <div  class="col-12 md:col-2 lg:col-2 p-1" >
        <app-input-text name="metodo"   placeholder="Metodo" [form]="toFormGroup(element)"></app-input-text>
      </div>
      <!--
      nel caso precisione decimale sia 1 allora posso usare sia interi che decimal
      <div class="col-12 md:col-4 lg:col-3 p-1" *ngIf="item?.precisioneDecimale==1">
        <app-input-number name="valore" [integer]="false" placeholder="Valore" [form]="toFormGroup(element)"></app-input-number>
      </div>
      nel caso precisione decimale non sia 1 e non sia null allora posso usare il campo precisioneDecimale
      <div  class="col-12 md:col-4 lg:col-3 p-1" *ngIf="item?.precisioneDecimale!=1 && item?.precisioneDecimale">
        <app-input-number name="valore" [step]="item?.precisioneDecimale!" placeholder="Valore" [form]="toFormGroup(element)"></app-input-number>
      </div>
      nel caso precisione decimale sia null allora posso usare solo valori interi
      <div  class="col-12 md:col-4 lg:col-3 p-1" *ngIf="!item?.precisioneDecimale">
        <app-input-number name="valore"  [integer]="true" placeholder="Valore" [form]="toFormGroup(element)"></app-input-number>
      </div>
    </div>-->
  </div>
  <div class="col-auto flex flex-column align-items-center justify-content-center">
    <ng-content select="[action]"></ng-content>
  </div>
</div>
